/**
 * This is a patch to fix the incompatibility with rc-resize-observer and React 19. I'm sorry.
 * React-DOM in v19 finally removed findDOMNode in favour of refs, but rc-resize-observer still uses findDOMNode,
 * even though it is deprecated.
 *
 * Sincerely, George.
 *
 * Source: https://github.com/ant-design/ant-design/issues/43064#issuecomment-2456508430.
 */

import RcResizeObserver from "rc-resize-observer";

/** Monkey patching here */
/** @ts-expect-error this is a hack */
// eslint-disable-next-line no-underscore-dangle
const _render = RcResizeObserver.render;
/** @ts-expect-error this is a hack */
RcResizeObserver.render = (props, ref) => _render(
  {
    ...props,
    children:
        typeof props.children === "function" ? (
          props.children
        ) : (
          <span ref={ref}>{props.children}</span>
        ),
  },
  ref,
);
